import { IMAGES } from "@/constants/landingAssets";

export default function AISection({ t }) {
  return (
    <section id="ai-section" className="py-20 bg-gray-900" data-testid="ai-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold text-[#CDA34F] uppercase tracking-[0.2em] mb-3 bg-[#CDA34F]/10 px-4 py-1.5 rounded-full">{t.ai.suptitle}</span>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4">{t.ai.title}</h2>
          <p className="text-base text-gray-400 max-w-2xl mx-auto">{t.ai.subtitle}</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.ai.items.map((item, i) => (
            <div key={i} className="bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 rounded-2xl p-6 hover:border-[#CDA34F]/40 transition-colors group" data-testid={`ai-feature-${i}`}>
              <div className="flex items-center justify-between mb-4">
                <div className="w-11 h-11 rounded-xl bg-[#CDA34F]/15 flex items-center justify-center group-hover:bg-[#CDA34F]/25 transition-colors"><item.icon className="w-5 h-5 text-[#CDA34F]" /></div>
                <span className="text-[10px] font-bold text-[#CDA34F] bg-[#CDA34F]/10 px-2.5 py-1 rounded-full tracking-wider">{item.tag}</span>
              </div>
              <h3 className="font-bold text-white mb-2">{item.title}</h3>
              <p className="text-sm text-gray-400 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
        <div className="flex justify-center mt-12">
          <img src={IMAGES.aiVisual} alt="AI" className="max-w-2xl w-full rounded-2xl opacity-80" />
        </div>
      </div>
    </section>
  );
}
